import _defineProperty from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _slicedToArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import { useUncontrolled, useDidUpdate } from '@mantine/hooks';
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;

var __defNormalProp = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};

var __spreadValues = function __spreadValues(a, b) {
  for (var prop in b || (b = {})) {
    if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  }

  if (__getOwnPropSymbols) {
    var _iterator = _createForOfIteratorHelper(__getOwnPropSymbols(b)),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var prop = _step.value;
        if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }

  return a;
};

var __spreadProps = function __spreadProps(a, b) {
  return __defProps(a, __getOwnPropDescs(b));
};

function createAccordionState(length) {
  var initialItem = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : -1;
  return Array.from({
    length: length
  }).reduce(function (acc, _item, index) {
    acc[index] = index === initialItem;
    return acc;
  }, {});
}

function useAccordionState(_ref) {
  var initialState = _ref.initialState,
      total = _ref.total,
      _ref$initialItem = _ref.initialItem,
      initialItem = _ref$initialItem === void 0 ? -1 : _ref$initialItem,
      state = _ref.state,
      onChange = _ref.onChange,
      _ref$multiple = _ref.multiple,
      multiple = _ref$multiple === void 0 ? false : _ref$multiple;

  var _useUncontrolled = useUncontrolled({
    value: state,
    defaultValue: initialState || createAccordionState(total, initialItem),
    finalValue: {},
    onChange: onChange,
    rule: function rule(val) {
      return val !== null && typeof val === "object";
    }
  }),
      _useUncontrolled2 = _slicedToArray(_useUncontrolled, 2),
      value = _useUncontrolled2[0],
      setState = _useUncontrolled2[1];

  var toggle = function toggle(index) {
    if (multiple) {
      setState(__spreadProps(__spreadValues({}, value), _defineProperty({}, index, !value[index])));
    } else {
      var newValues = Array(total).fill(0).reduce(function (acc, _, itemIndex) {
        acc[itemIndex] = false;
        return acc;
      }, {});
      newValues[index] = !value[index];
      setState(newValues);
    }
  };

  useDidUpdate(function () {
    if (!multiple) {
      setState(createAccordionState(total));
    }
  }, [multiple]);
  return [value, {
    toggle: toggle,
    setState: setState
  }];
}

export { createAccordionState, useAccordionState };